<template>
  <span>{{ decoder.description
  }}<span
    v-if="hasSlaves && !isMultiscreenFormat"
  ><span
    v-for="(
      slaveDecoder, slaveDecoderIndex
    ) in decoder.slave_decoder_serials_and_descriptions"
    :key="slaveDecoder.serial"
    class="grey--text text--darken-1"
  ><span
    v-if="
      slaveDecoderIndex <
        decoder.slave_decoder_serials_and_descriptions.length
    "
  >, </span>{{ slaveDecoder.description }}
  </span>
  </span></span>
</template>

<script>
export default {
  props: {
    decoder: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasSlaves() {
      return (
        this.decoder.slave_decoder_serials_and_descriptions &&
        this.decoder.slave_decoder_serials_and_descriptions.length > 0
      );
    },
    isMultiscreenFormat() {
      return (
        this.decoder.ctype == 'tv' &&
        this.decoder.tvformat &&
        this.decoder.tvformat.is_multiscreen_format
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/DecoderDescription.vue